import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
});

export const filters: TRuleWithTheme = () => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // Below `min768` the search field is full width, so it takes a row of its own and leaves the
    // docs link on the one above it.
    flexWrap: 'wrap',
    gap: '1rem',

    minHeight: '2.5rem',
});

export const docsLink: TRuleWithTheme = () => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',

    whiteSpace: 'nowrap',
});

export const docsLinkIcon: TRuleWithTheme = () => ({
    flexShrink: 0,
});

export const filtersStart: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.5rem 1.5rem',

    minWidth: 0,
});

export const baseUrl: TRuleWithTheme = () => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.375rem',

    minWidth: 0,
});

export const baseUrlValue: TRuleWithTheme = () => ({
    minWidth: 0,

    overflowWrap: 'anywhere',
});

export const searchInput: TRuleWithTheme = () => ({
    width: '100%',

    '&.ant-input-affix-wrapper': {
        height: '2.25rem',
    },

    min768: {
        maxWidth: '15.625rem',
    },
});

// The bordered box comes from the shared Table's own `& table` border; drawing one here too
// nests a second, inset border inside it.
export const stateBox: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    width: '100%',
    minHeight: '5rem',
});

export const errorAlert: TRuleWithTheme = () => ({
    '&.ant-alert': {
        marginBottom: 0,
        textAlign: 'center',
    },
});

// Every column sits flush against the table edge except the trailing action column, which the
// design insets — the shared `Table` zeroes the inline cell padding on its own.
export const table: TRuleWithTheme = () => ({
    '& .ant-table-thead > tr > th:last-child, & .ant-table-tbody > tr > td:last-child': {
        paddingRight: '0.75rem',
    },

    // Antd's checkbox label carries a 22px line box, which is taller than the 18px text line the
    // rest of the row sits on and would stretch the 40px row by 4px.
    '& .ant-table-tbody .ant-checkbox-wrapper': {
        lineHeight: '1.125rem',
    },
});

// Only the hovered row reveals the action. Fading beats `visibility: hidden`, which would drop a
// destructive action out of the accessibility tree; the unqualified `opacity` also stays less
// specific than the shared `visible-on-row-hover` reveal, so hover always wins.
export const revokeButton: TRuleWithTheme = () => ({
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',

    ':focus-visible': {
        opacity: 1,
    },

    // The shared text-button rule makes the button a flex container that still shrinks to its
    // content, so the cell's `text-align` cannot move it — the auto margin does.
    '&.ant-btn-text': {
        marginLeft: 'auto',
        gap: '0.25rem',

        height: 'auto',

        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: '1rem',
    },
});
